import { useState, useEffect } from "react";

export function useIsMobile(breakpoint: number = 768): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    const isSmallScreen = window.innerWidth < breakpoint;
    const isMobileUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    return isSmallScreen || isMobileUA;
  });

  useEffect(() => {
    const checkMobile = () => {
      const isSmallScreen = window.innerWidth < breakpoint;
      const isMobileUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      setIsMobile(isSmallScreen || isMobileUA);
    };

    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handleChange = () => checkMobile();

    mql.addEventListener("change", handleChange);
    window.addEventListener("resize", handleChange);

    checkMobile();

    return () => {
      mql.removeEventListener("change", handleChange);
      window.removeEventListener("resize", handleChange);
    };
  }, [breakpoint]);

  return isMobile;
}
